import React, { Component } from 'react';
import FormFilters from '../FormFilters';

const PADROES = [
    { value: 'Compacto', label: 'Compacto' },
    { value: 'Econômico', label: 'Econômico' },
    { value: 'Standard', label: 'Standard' },
    { value: 'Médio', label: 'Médio' },
    { value: 'Alto', label: 'Alto' },
    { value: 'Alto +', label: 'Alto +' },
    { value: 'Luxo', label: 'Luxo' },
    { value: 'Super Luxo', label: 'Super Luxo' },
];

const STATUS_OPTIONS = [
    { value: 'Ativo', label: 'Ativo' },
    { value: 'Esgotado', label: 'Esgotado' },
    { value: 'Futuro', label: 'Futuro' },
    { value: 'Suspenso', label: 'Suspenso' },
];

const INITIAL_STATE = {
    cidade: [],
    estado: [],
    estadosSelecionados: [],
    regiao: [],
    bairros: [],
    bairrosOptions: [],
    status: ['Ativo'],
    tipo_empreendimento: [],
    padrao: [],
    retrofit: [],
    nome_empreendimento: [],
    incorporadoras: [],
    projetos: [{ value: null, label: 'Selecione' }],
    projeto: '',
    valor_maior_que: '', valor_menor_que: '',
    valor_metro_maior_que: '', valor_metro_menor_que: '',
    area_maior_que: '', area_menor_que: '',
    porcentagem_vendida_minima: '', porcentagem_vendida_maxima: '',
    valor_parcela_minima: '', valor_parcela_maxima: '',
    valor_parcela_minimo: '', valor_parcela_maximo: '',
    juros_minimo: '', juros_maximo: '',
    parcelas_minimo: '', parcelas_maximo: '',
    ano_lancamento: [], mes_ano_lancamento: '',
    estagio: [],
    quartos: [], vagas: [],
    raio: 3000,
    cluster: '', opcoes_clustes: [],
    busca_por_estado: false,
    tipo_negocio: [],
    buscaEmpreendimentossDefaultOptions: [],
    inputEstadoValue: '', inputBairroValue: '',
    overlays: [],
    ranges: [],
    address: '',
    use_cluster: false,
    showMarkers: true,
    show_polos_geradores: false,
    polos_geradores_types_selected: [],
    showResaleOrLocationMarkers: false,
};

/**
 * Encapsula todo o estado do FormFilters e expõe APENAS:
 *  - onSubmit(filters) — chamado quando "BUSCAR" é clicado, recebe os filtros relevantes
 *  - onClear()         — chamado quando "LIMPAR" é clicado
 *  - onEstadosChanged(ufs) — chamado quando o MultiSelect de Estado muda (ex.: centralizar na capital)
 *  - onProjetoSelected(id) — chamado quando um projeto é escolhido no "Carregar projeto"
 *  - cidadeSincronizada — cidade vinda do parent (ex.: search box) que atualiza o select
 */
class FormFiltersContainer extends Component {
    state = { ...INITIAL_STATE };

    componentDidUpdate(prevProps) {
        // Sincroniza cidade externa (ex.: search box do mapa) → MultiSelect de cidade
        if (this.props.cidadeSincronizada !== prevProps.cidadeSincronizada && this.props.cidadeSincronizada) {
            const cidade = this.props.cidadeSincronizada;
            const estados = [...new Set(cidade.map((c) => (c.value || '').split('-')[0]))];
            this.setState({ cidade, estadosSelecionados: estados });
        }
    }

    // ===== Setters genéricos =====
    setValue = (key) => (e) => this.setState({ [key]: e.value });
    setRaw   = (key) => (e) => this.setState({ [key]: e });
    setInput = (key) => (e) => this.setState({ [key]: e.target.value });

    // ===== Handlers (delegam aos setters quando trivial) =====
    handleStatusChanged   = this.setValue('status');
    handlePadraoChanged   = this.setValue('padrao');
    handleRetrofitChanged = this.setValue('retrofit');
    handleRegiaoChanged   = this.setValue('regiao');
    handleEstadosChanged  = (e) => {
        this.setState({ estadosSelecionados: e.value });
        this.props.onEstadosChanged?.(e.value || []);
    };
    handleBairrosChanged  = this.setValue('bairros');
    handleAnoLancamentoChanged = this.setValue('ano_lancamento');
    handleEstagioChanged  = this.setValue('estagio');
    handleQuartosChanged = (tipo) => {
        const list = this.state.quartos;
        const next = list.includes(tipo) ? list.filter((t) => t !== tipo) : [...list, tipo];
        this.setState({ quartos: next });
    };
    handleVagasChanged    = this.setValue('vagas');
    handleProjetoChanged  = (e) => {
        this.setState({ projeto: e.value });
        if (e.value != null) this.props.onProjetoSelected?.(e.value);
    };
    handleClusterChanged  = this.setValue('cluster');

    handleCidadeChanged = (cidade) => {
        if (cidade == null) {
            this.setState({ cidade: [], estado: [] });
            return;
        }
        const list = Array.isArray(cidade) ? cidade : [cidade];
        const estado = [...new Set(list.map((c) => (c.value || '').split('-')[0]))];
        this.setState({ cidade: list, estado });
    };

    handleEstadosChangedInput = this.setRaw('inputEstadoValue');
    handleBairroChangedInput  = this.setRaw('inputBairroValue');
    handleMesAnoLancamentoChanged = this.setRaw('mes_ano_lancamento');
    handleRaioChanged = this.setRaw('raio');
    handleNomeEmpreendimentoChanged = (e) => this.setState({ nome_empreendimento: e || [] });
    handleIncorporadoraChanged = (e) => this.setState({ incorporadoras: e || [] });

    handleTipoEmpreendimentoChanged = (tipo) => {
        const list = this.state.tipo_empreendimento;
        const next = list.includes(tipo) ? list.filter((t) => t !== tipo) : [...list, tipo];
        this.setState({ tipo_empreendimento: next });
    };

    handleAreaMinimaChanged = this.setInput('area_maior_que');
    handleAreaMaximaChanged = this.setInput('area_menor_que');
    handleValorMinimoChanged = this.setRaw('valor_maior_que');
    handleValorMaximoChanged = this.setRaw('valor_menor_que');
    handleValorMetroMinimoChanged = this.setRaw('valor_metro_maior_que');
    handleValorMetroMaximoChanged = this.setRaw('valor_metro_menor_que');
    handlePorcentagemVendidaMinimaChanged = this.setInput('porcentagem_vendida_minima');
    handlePorcentagemVendidaMaximaChanged = this.setInput('porcentagem_vendida_maxima');
    handleJurosMinimoChanged = this.setInput('juros_minimo');
    handleJurosMaximoChanged = this.setInput('juros_maximo');
    handleParcelasMinimoChanged = this.setInput('parcelas_minimo');
    handleParcelasMaximoChanged = this.setInput('parcelas_maximo');
    handleValorParcelaMinimaChanged = this.setRaw('valor_parcela_minima');
    handleValorParcelaMaximaChanged = this.setRaw('valor_parcela_maxima');
    handleTipoChanged = (e) => this.setState({ tipo_negocio: e ? [e.value] : [] });
    handleChangedArray = (key, value) => this.setState({ [key]: value });

    setBuscaPorEstado = this.setRaw('busca_por_estado');
    toggleUseCluster  = () => this.setState({ use_cluster: !this.state.use_cluster });
    setShowMarkers    = this.setRaw('showMarkers');
    setShowPolosGeradores = this.setRaw('show_polos_geradores');
    setPolosGeradoresTypes = this.setRaw('polos_geradores_types_selected');
    openModalPolosGeradores = () => {};
    openModalWork = () => {};

    clearDefaultEmpreendimentos = () => this.setState({ buscaEmpreendimentossDefaultOptions: [] });

    searchEmpreendimentos = async (input) => {
        if (input.length < 2) return [];
        try {
            const res = await axios.get(`/empreendimentos-json?empreendimento=${encodeURIComponent(input)}`);
            return res.data;
        } catch {
            return [];
        }
    };

    getProjects = async () => {
        try {
            const response = await axios.get(route('getMapaProjetos'));
            this.setState({ projetos: [{ value: null, label: 'Selecione' }, ...response.data.projects] });
        } catch (e) {
            console.error('[FormFiltersContainer] erro ao carregar projetos:', e);
        }
    };

    // Aplica os filtros de um projeto carregado (chamado via ref): reseta para o
    // estado inicial preservando a lista/seleção de projetos e mescla os valores.
    applyProjectFilters = (filters) =>
        new Promise((resolve) =>
            this.setState(
                { ...INITIAL_STATE, projetos: this.state.projetos, projeto: this.state.projeto, ...filters },
                resolve
            )
        );

    getPadroes  = () => PADROES;

    // ===== Ações expostas ao parent =====
    /**
     * Retorna os filtros atuais no mesmo formato esperado por onSubmit.
     * Exposto para que o parent (ex.: busca por endereço) reaproveite os
     * filtros já selecionados ao disparar uma busca.
     */
    getFilters = () => ({
        cidades: this.state.cidade,
        status:  this.state.status,
        tipo:    this.state.tipo_empreendimento,
        padrao:  this.state.padrao,
        estados: this.state.estadosSelecionados,
        bairros: this.state.bairros,
        incorporadoras: this.state.incorporadoras,
        nome_empreendimento: this.state.nome_empreendimento,
        quartos: this.state.quartos,
        area_maior_que: this.state.area_maior_que,
        area_menor_que: this.state.area_menor_que,
        valor_maior_que: this.state.valor_maior_que,
        valor_menor_que: this.state.valor_menor_que,
        valor_metro_maior_que: this.state.valor_metro_maior_que,
        valor_metro_menor_que: this.state.valor_metro_menor_que,
        porcentagem_vendida_minima: this.state.porcentagem_vendida_minima,
        porcentagem_vendida_maxima: this.state.porcentagem_vendida_maxima,
        ano_lancamento: this.state.ano_lancamento,
        mes_ano_lancamento: this.state.mes_ano_lancamento,
        estagio: this.state.estagio,
        retrofit: this.state.retrofit,
        juros_minimo: this.state.juros_minimo,
        juros_maximo: this.state.juros_maximo,
        parcelas_minimo: this.state.parcelas_minimo,
        parcelas_maximo: this.state.parcelas_maximo,
        valor_parcela_minima: this.state.valor_parcela_minima,
        valor_parcela_maxima: this.state.valor_parcela_maxima,
    });

    handleSubmit = () => {
        this.props.onSubmit?.(this.getFilters());
    };

    cleanState = () => {
        this.setState({ ...INITIAL_STATE });
        this.props.onClear?.();
    };

    downloadKml = () => this.props.onDownloadKml?.();

    render() {
        return (
            <FormFilters
                {...this.state}
                area_minima={this.state.area_maior_que}
                area_maxima={this.state.area_menor_que}
                incorporators={this.state.incorporadoras}
                showLegenda={this.props.showLegenda}
                showPolosGeradores={this.state.show_polos_geradores}
                open_modal_polos_geradores={this.openModalPolosGeradores}
                statusOptions={STATUS_OPTIONS}
                /* handlers — agrupados por afinidade de domínio */
                handleSubmit={this.handleSubmit}
                cleanState={this.cleanState}
                downloadKml={this.downloadKml}
                openModalWork={this.openModalWork}

                clearDefaultEmpreendimentos={this.clearDefaultEmpreendimentos}
                searchEmpreendimentos={this.searchEmpreendimentos}
                getProjects={this.getProjects}
                getPadroes={this.getPadroes}

                handleCidadeChanged={this.handleCidadeChanged}
                handleEstadosChanged={this.handleEstadosChanged}
                handleEstadosChangedInput={this.handleEstadosChangedInput}
                handleBairrosChanged={this.handleBairrosChanged}
                handleBairroChangedInput={this.handleBairroChangedInput}
                handleRegiaoChanged={this.handleRegiaoChanged}
                handleChangedArray={this.handleChangedArray}

                handleStatusChanged={this.handleStatusChanged}
                handlePadraoChanged={this.handlePadraoChanged}
                handleRetrofitChanged={this.handleRetrofitChanged}
                handleProjetoChanged={this.handleProjetoChanged}
                handleClusterChanged={this.handleClusterChanged}
                handleTipoChanged={this.handleTipoChanged}
                handleTipoEmpreendimentoChanged={this.handleTipoEmpreendimentoChanged}

                handleNomeEmpreendimentoChanged={this.handleNomeEmpreendimentoChanged}
                handleIncorporadoraChanged={this.handleIncorporadoraChanged}
                handleAnoLancamentoChanged={this.handleAnoLancamentoChanged}
                handleMesAnoLancamentoChanged={this.handleMesAnoLancamentoChanged}
                handleEstagioChanged={this.handleEstagioChanged}
                handleQuartosChanged={this.handleQuartosChanged}
                handleVagasChanged={this.handleVagasChanged}
                handleRaioChanged={this.handleRaioChanged}

                handleAreaMinimaChanged={this.handleAreaMinimaChanged}
                handleAreaMaximaChanged={this.handleAreaMaximaChanged}
                handleValorMinimoChanged={this.handleValorMinimoChanged}
                handleValorMaximoChanged={this.handleValorMaximoChanged}
                handleValorMetroMinimoChanged={this.handleValorMetroMinimoChanged}
                handleValorMetroMaximoChanged={this.handleValorMetroMaximoChanged}
                handlePorcentagemVendidaMaximaChanged={this.handlePorcentagemVendidaMaximaChanged}
                handlePorcentagemVendidaMinimaChanged={this.handlePorcentagemVendidaMinimaChanged}
                handleJurosMinimoChanged={this.handleJurosMinimoChanged}
                handleJurosMaximoChanged={this.handleJurosMaximoChanged}
                handleParcelasMinimoChanged={this.handleParcelasMinimoChanged}
                handleParcelasMaximoChanged={this.handleParcelasMaximoChanged}
                handleValorParcelaMinimaChanged={this.handleValorParcelaMinimaChanged}
                handleValorParcelaMaximaChanged={this.handleValorParcelaMaximaChanged}

                toggleUseCluster={this.toggleUseCluster}
                setShowMarkers={this.setShowMarkers}
                setShowPolosGeradores={this.setShowPolosGeradores}
                setPolosGeradoresTypes={this.setPolosGeradoresTypes}
                setBuscaPorEstado={this.setBuscaPorEstado}
            />
        );
    }
}

export default FormFiltersContainer;
